<template>
  <v-col>
    <v-row no-gutters v-if="hasTitle">
      <card-title-row is-subtitle :amount="1" :is-plural="true" :straight-title="name" class="pt-3" />
    </v-row>
    <div class="pt-5">
      <v-row no-gutters v-for="(allowedValue, idx) of allowed_values" :key="idx">
        <v-checkbox
          class="py-0 my-0 black-label"
          color="primary"
          @change="setFilter"
          :label="allowedValue"
          :value="allowedValue"
          v-model="checkedValues"
        >
          <template #label>
            <v-row no-gutters class="checkbox-label">
              {{ allowedValue }}
            </v-row>
          </template>
        </v-checkbox>
      </v-row>
    </div>
  </v-col>
</template>
<script>
import CardTitleRow from '@/components/CardTitleRow';
export default {
  name: 'SidebarCheckboxFilter',
  components: {
    CardTitleRow,
  },
  data: () => ({
    checkedValues: [],
  }),
  props: {
    allowed_values: {
      type: Array,
      default: () => [],
    },
    hasTitle: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    setFilter(value) {
      this.$root.$emit('setSidebarFilters', { type: value.length === 0 ? ['-'] : value });
    },
  },
  mounted() {
    this.checkedValues = this.allowed_values;
  },
};
</script>
<style lang="scss" scoped>
.checkbox-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
}
</style>
